import { useRouter } from 'next/router'

import curriculumAnalytics from '~/analytics/curriculum/curriculumAnalytics'
import { CATEGORY_COLORS } from '~/bootcamp/constants/bootcamp.const'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import SVGImage from '~/components/Image/SVGImage'
import { Link } from '~/components/Link'
import { TopicId } from '~/dashboard/utils/learningPath.utils'
import { useAppDispatch } from '~/redux/hooks'
import { setSelectedGradeActionCreator } from '~/redux/slices/dashboard'
import { AppLanguage } from '~/types/locale'
import { LevelSource } from '~/curriculum/constants/curriculum.const'

import {
  useGetCurriculumCountryCodeFromUrlWithoutPrefix,
  useGetIsNorwegianCurriculum,
} from '../hooks/useGetCurriculumCountryCode'

export default function MathVaultLevel({
  levelTitle,
  path,
  globalId,
  topic,
  isCompleted,
  onClick,
  source = LevelSource.CURRICULUM,
}: {
  levelTitle: string
  path: string
  globalId: string
  topic: TopicId
  isCompleted: boolean
  onClick: (title: string) => void
  source?: LevelSource.CURRICULUM | LevelSource.PRE_REQUISITE
}): React.ReactElement {
  const dispatch = useAppDispatch()
  const borderColorClass = CATEGORY_COLORS[topic]?.borderClass
  const router = useRouter()
  const currLocale = router.locale as AppLanguage
  const curriculumCountryCodeFromUrl = useGetCurriculumCountryCodeFromUrlWithoutPrefix()
  const isNorwegianCurriculum = useGetIsNorwegianCurriculum(curriculumCountryCodeFromUrl)
  const expectedLocale = isNorwegianCurriculum
    ? AppLanguage.NO
    : currLocale === AppLanguage.NO
    ? AppLanguage.EN
    : currLocale

  const { grade } = router.query

  const setSelecetdGrade = (): void => {
    if (grade) {
      dispatch(setSelectedGradeActionCreator(parseInt(grade as string, 10)))
      curriculumAnalytics.logGradeLevelClick(
        'math_vault',
        levelTitle,
        {
          globalId,
          source,
        },
        'v1',
      )
    }
    onClick(levelTitle)
  }

  return (
    <Link
      className={`flex items-center p-0.5 rounded border-4 ${
        isCompleted ? 'bg-purple-darker text-white border-white' : `bg-white ${borderColorClass}`
      }`}
      locale={expectedLocale}
      onClick={setSelecetdGrade}
      to={{ pathname: path, query: { showGrade: 'true' } }}
    >
      <div className="relative flex justify-center items-center h-14 w-14 min-w-11.5">
        {isCompleted && (
          <SVGImage className="min-w-12" height={34} srcKey="bootcamp/checkmark-white-border.svg" width={34} />
        )}
        <ResponsiveImage
          className={`flex scale-125 ${isCompleted ? 'absolute w-full -top-6 -left-5 drop-shadow-white' : ''}`}
          fit="contain"
          height={48}
          imageWidths="150"
          srcKey={
            isNorwegianCurriculum
              ? 'gamification/JuniorMath/NOJuniorMathIcon.png'
              : 'gamification/games/junior-math.png'
          }
          width={50}
        />
      </div>
      <p className="text-base tracking-px">{levelTitle}</p>
    </Link>
  )
}
